/// <amd-module name="Test/TestResultsSettings/Components/TestResultsNewTestsLoggingSettingsView" />
import * as React from "react";
import * as TCMContracts from "Test/common-util/Contracts/Test";
import * as Telemetry from "Test/common-util/Telemetry";
import * as TelemetryConstants from "Test/common-util/TelemetryConstants";
import * as Resources from "Test/TestResultsSettings/Resources";
import { ITestResultsSettingsState, TestResultsSettingsStore } from "Test/TestResultsSettings/Store/TestResultsSettingsStore";
import { ObservableValue } from "VSS/Core/Observable";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { CardContent, CustomCard } from "VSSUI/Card";
import { Checkbox } from "VSSUI/Checkbox";
import { CustomHeader, HeaderDescription, HeaderTitle, HeaderTitleArea, HeaderTitleRow, TitleSize } from "VSSUI/Header";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { IVssPageContext } from "VSS/Platform/Context";
import { ITestSettingsProps } from "Test/TestResultsSettings/Components/TestResultsFlakySettingsView";

export class TestResultsNewTestsLoggingSettingsView extends VssComponent<ITestSettingsProps, ITestResultsSettingsState> {
    private _store: TestResultsSettingsStore;
    private _pageContext: IVssPageContext;
    private _enableNewTestLoggingSettings: string;

    constructor(props: ITestSettingsProps, context: IVssComponentContext) {
        super(props, context);
        this._store = props.store;
        this._pageContext = context.pageContext;
        this.state = props.state;
        this._enableNewTestLoggingSettings = "WebAccess.TestManagement.ShowNewTestLoggingSettings";
    }

    public componentDidMount(): void {
        super.componentDidMount();
        this._store.addChangedListener(this._handleStoreChange);
        this.state.storeNewTestsState.settingsObservable.subscribe(this._onNewTestSettingsStateChanged);
    }

    public componentWillUnmount() {
        this.state.storeNewTestsState.settingsObservable.unsubscribe(this._onNewTestSettingsStateChanged);
        this._store.removeChangedListener(this._handleStoreChange);
        super.componentWillUnmount();
    }

    public render(): JSX.Element[] {
        const shouldShow = isFeatureFlagEnabled(this._pageContext, this._enableNewTestLoggingSettings, false)
        if(shouldShow){
            if (this.state.loading) {
                return [];
            }
            return [this._getNewTestsLogging(Resources.NewTestsOptionsText, "", true, this._newTestLoggingValue)];
        }
        return [];
    }

    private get _newTestLoggingValue(): ObservableValue<boolean> {
        return this.state.storeNewTestsState.settingsObservable;
    }

    private _handleStoreChange = (): void => {
        this.setState(this._store.getState());
    };

    private _onNewTestSettingsStateChanged = async (newVal: boolean) => {
        const newValueBool = newVal;
        if (newValueBool !== this.state.storeNewTestsState.settingsData) {
            const testResultsUpdateSettings: TCMContracts.TestResultsUpdateSettings = {
                flakySettings: {} as TCMContracts.FlakySettings,
                newTestResultLoggingSettings: {} as TCMContracts.NewTestResultLoggingSettings
            };
            testResultsUpdateSettings.flakySettings = this._mapSettingsFromState();
            testResultsUpdateSettings.newTestResultLoggingSettings.logNewTests = newValueBool;
            const success = await this._store.updateTestResultsSettings(testResultsUpdateSettings);
            if (success) {
                Telemetry.publishEvent(this.context.pageContext, this.context.pageContext, TelemetryConstants.featureNewTestLoggingSettings, {
                    logNewTests: newValueBool
                });
            }
        }
    };

    private _mapSettingsFromState(): TCMContracts.FlakySettings{
        const flakySettings= { } as TCMContracts.FlakySettings;
        flakySettings.manualMarkUnmarkFlaky = this.state.manualMarkUnmarkState.settingsData;
        flakySettings.flakyInSummaryReport = this.state.summaryReportSettingsState.settingsData
        return flakySettings
    }

    private _getNewTestsLogging(
        headerTitle: string,
        headerDescription: string,
        newTestsLoggingToggle: boolean,
        newTestsLogging: ObservableValue<boolean>
    ) {
        return (
            <CustomCard className="flex-grow bolt-card-with-header settings-card setting-card-bottom-margin" key={headerTitle}>
                <CustomHeader className="bolt-card-header flex-center bolt-header-with-commandbar">
                    <HeaderTitleArea>
                        <HeaderTitleRow>
                            <HeaderTitle titleSize={TitleSize.Medium}>{headerTitle}</HeaderTitle>
                            <HeaderDescription>{headerDescription}</HeaderDescription>
                        </HeaderTitleRow>
                    </HeaderTitleArea>
                </CustomHeader>
                <CardContent>
                    <div className="flex-column">
                        <Checkbox
                            className="checkbox-radio-section"
                            disabled={!newTestsLoggingToggle}
                            onChange={(event, newValue) => (newTestsLogging.value = newValue)}
                            checked={newTestsLogging}
                            label={
                                <div className="flex-column">
                                    {Resources.NewTestsLoggingText}
                                    <div className="secondary-text">{Resources.NewTestsLoggingDescriptionText}</div>
                                </div>
                            }
                        />
                    </div>
                </CardContent>
            </CustomCard>
        );
    }
}

